import { GetAdminEventResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/**
 * Fetches one event's admin detail (GET /v1/admin/events/:id). Disabled until the
 * id is a valid positive number. Gated server-side by AdminGuard; a missing id
 * returns 404.
 */
export const useAdminEvent = (id: number) => {
	return useQuery<GetAdminEventResponse>({
		queryKey: queryKeys.adminEvent(id),
		queryFn: async () => {
			const response = await api.get<GetAdminEventResponse>(`/admin/events/${id}`)
			return response.data
		},
		enabled: Number.isFinite(id) && id > 0,
	})
}
